var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 14",
    style: {
      enableBackground: "new 0 0 15 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M6.9,0.6c-2.3,0-4.4,1.3-5.4,3.3h1.7C4.1,2.8,5.5,2.1,6.9,2c2.2,0,4.2,1.6,4.5,3.8l-1.3,0l1,1.7l1,1.7l1-1.7 l1-1.7l-1.2,0C12.5,2.9,10,0.6,6.9,0.6z M2.1,4.8l-1,1.7l-1,1.7l1.2,0c0.4,3,2.9,5.3,6,5.3c2.3,0,4.4-1.3,5.4-3.3H11 C10.2,11.3,8.8,12,7.3,12c-2.2,0-4.2-1.6-4.5-3.8l1.3,0l-1-1.7L2.1,4.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6d6706c9c4c24655e32823d17e0cfe10.svg";
export { ForwardRef as ReactComponent };